import $ from 'jquery';
import { setCookie, getCookie } from 'utils/cookies';

const engagementAlertInit = () => {
    const $section = $('.s-engagement-alert');

    if ($section.length === 0) return;

    $section.each(function () {
        const $el = $(this);
        const cookieName = $el.data('alert-id');
        const cookie = getCookie(cookieName);

        if (!cookie) {
            $el.removeClass('hide');
        }

        $el.find('.close-alert').click(() => {
            $el.addClass('hide');
            setCookie(cookieName, 1, 1);
        });
    });
};

// doc ready
$(() => {
    engagementAlertInit();
});
